// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1StateSchema } from './v1/stateSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listHourStatesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listHourStatesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Time entry states list
 */
export const listHourStates200Schema = z.array(z.lazy(() => v1StateSchema));

/**
 * @description Unauthorized
 */
export const listHourStates401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listHourStatesQueryResponseSchema = z.lazy(() => listHourStates200Schema);
